/**
 * Formats a date string or Date object to MM/DD/YYYY h:mm AM/PM format
 * @param dateInput - Date string, Date object, or undefined
 * @returns Formatted date string in MM/DD/YYYY h:mm AM/PM format
 * @example
 * formatDateTime('2025-03-15T14:30:00') // Returns "03/15/2025 2:30 PM"
 * formatDateTime(new Date()) // Returns current date formatted
 * formatDateTime() // Returns current date formatted
 */
export const formatDateTime = (dateInput?: string | Date): string => {
  const date = dateInput ? new Date(dateInput) : new Date();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
};
